import React from 'react';
import { Box, Typography, Button, useTheme } from '@mui/material';
import { Link } from "react-router-dom";

export default function InsightsHerosection() {


    const theme = useTheme();
    const isDarkMode = theme.palette.mode === 'dark';
    // const [showVideo, setShowVideo] = useState(false);

    return (
        <Box
            sx={{
                width: '100%',
                height: { xs: 'auto', md: '600px' },
                py: 8,
                px: { xs: 4, md: 10 },
                // backgroundImage: isDarkMode ? 'none' : 'url("/Intrinsic CTMS.png")',
                // backgroundColor: isDarkMode ? '#333738' : 'transparent',
                backgroundImage: 'url("/IntrinsicRMHeader.png")',
                backgroundSize: 'cover',
                backgroundPosition: 'center',
                backgroundRepeat: 'no-repeat',
                boxSizing: 'border-box',
                display: 'flex',
                //flexDirection: { xs: 'column', md: 'row' },
                flexDirection: 'column',
                alignItems: 'center',
                justifyContent: 'center',
                color: isDarkMode ? '#ffffff' : '#2b2b2b',
                textAlign: { xs: 'center' },
            }}
        >
            {/* Left Side - Text */}
            <Box sx={{ flex: 1, pr: { md: 6 }, mb: { xs: 4, md: 0 } }}>
                {/* Logo + Title */}
                <Box
                    sx={{
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: { xs: 'center' },
                        mb: 2,
                    }}
                >
                    <img
                        src="/Blue_Group_of_people_Insights_RM.png"
                        alt="Intrinsic CTMS"
                        style={{ height: 60, marginRight: 8 }}
                    />
                    <Box sx={{ display: 'flex', flexDirection: 'column', }}>
                        <Typography
                            variant="h5"
                            sx={{
                                fontWeight: 800,
                                fontSize: '2rem',
                                color: isDarkMode ? '#2b2b2b' : '#2b2b2b',

                                px: 1,
                            }}
                        >
                            INSIGHTS RM
                        </Typography>

                    </Box>
                </Box>


                {/* Headline */}
                <Typography
                    variant="h4"
                    sx={{
                        fontWeight: 300,
                        mb: 2,
                        lineHeight: 1.3,
                           color: isDarkMode ? '#2b2b2b' : '#2b2b2b',

                    }}
                >
                    Clinical Resource Management Precision
                </Typography>

                {/* Button */}
                <Button
                    variant="contained"
                    component={Link}
                    to="/request-demo"
                    sx={{
                        backgroundColor: '#0cc0df',
                        color: '#FFFFFF',
                        px: '40px',
                        py: '6px',
                        fontSize: '1.4rem',
                        borderRadius: '50px',
                        textTransform: 'none',
                        fontWeight: 500,
                        boxShadow: '0px 4px 12px rgba(0, 174, 239, 0.4)',
                        transition: 'transform 0.3s ease, background-color 0.3s ease',
                        '&:hover': {
                            backgroundColor: '#0cc0df',
                            transform: 'scale(1.05)',
                        },
                    }}
                >
                    Request a Demo
                </Button>


            </Box>

            {/* Right Side - Video */}

        </Box >
    );
}


